export default "__VITE_ASSET__DLkDTnG9__"